import { render } from "./BodyImpressum.vue?vue&type=template&id=2fe35569&scoped=true"
import script from "./BodyImpressum.vue?vue&type=script&lang=js"
export * from "./BodyImpressum.vue?vue&type=script&lang=js"

import "./BodyImpressum.vue?vue&type=style&index=0&id=2fe35569&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe35569"]])

export default __exports__